<app-modal-header [hasClose]='true' [title]="title" (handleClose)="close()"></app-modal-header>

@if (!loading) {
  <mat-dialog-content class="content-dialog">
    <mat-expansion-panel class="m20" hideToggle>
      <mat-expansion-panel-header>
        <div class="flex">
          <div>
            <mat-icon style="margin-right: 5px;">person</mat-icon> <span> {{data.itens[0]?.name}} </span> - <span>
          {{data.itens[0]?.cpf_number}} </span>
        </div>
        <mat-icon>add</mat-icon>
      </div>
    </mat-expansion-panel-header>
    <div>
      @for (item of data.itens | slice:1; track item) {
        <div class="div-info">
          <mat-icon style="margin-right: 5px;">person</mat-icon> <span> {{item.name}} </span> - <span>
        {{item.cpf_number}} </span>
      </div>
    }
  </div>
</mat-expansion-panel>
<mat-card class="m-b20">
  <form [formGroup]="examGeneratedForm" class="pd0">
    <p>Prova Atual (Particularidade): <strong>{{data.itens[0]?.exam_particularity}}</strong></p>
    @if (data.action == 2) {
      <mat-form-field>
        <textarea matInput placeholder="Justificativa" rows="3" formControlName="reason" required></textarea>
        @if (examGeneratedForm.get('reason').errors && examGeneratedForm.get('reason').touched) {
          <mat-error>
          {{examGeneratedForm.get('reason').errors['message']}}</mat-error>
        }
      </mat-form-field>
    }
    <mat-form-field>
      <mat-select matSelect formControlName="evaluator_manual_id" placeholder="Manual do avaliador" required>
        @for (item of evaluatorManual; track item) {
          <mat-option [value]="item.id">
            {{item.course.description}}
          </mat-option>
        }
      </mat-select>
      @if (examGeneratedForm.get('evaluator_manual_id').errors && examGeneratedForm.get('evaluator_manual_id').touched) {
        <mat-error>
        {{examGeneratedForm.get('evaluator_manual_id').errors['message']}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field>
      <mat-select matSelect formControlName="exam_id" placeholder="Prova prática" required>
        @for (item of exams; track item) {
          <mat-option [value]="item.id">
            {{item.particularity}}
          </mat-option>
        }
      </mat-select>
      @if (examGeneratedForm.get('exam_id').errors && examGeneratedForm.get('exam_id').touched) {
        <mat-error>
        {{examGeneratedForm.get('exam_id').errors['message']}}</mat-error>
      }
    </mat-form-field>
  </form>
</mat-card>
</mat-dialog-content>
}

@if (!loading) {
  <div class="modal-footer">
    <button mat-raised-button mat-dialog-close type="button" id="cancel">Cancelar</button>
    <button id="modalApplyBtn" class="primary-action-btn" mat-raised-button type="submit" (click)="examGenerated()" [disabled]="examGeneratedForm.invalid">{{btn}}</button>
  </div>
}

@if (loading) {
  <div class="center-loading">
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
}
